import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'

import ProjectListTable from '../../../components/project-profit-sheet/ProjectListTable'

import { ppsSelector } from '../../../selectors'

const mapStateToProps = createStructuredSelector({
  data: ppsSelector.overviews,
})

export default connect(mapStateToProps)(ProjectListTable)



// WEBPACK FOOTER //
// ./src/pages/project-profit-sheet/containers/OverviewListTable.js